import { render } from "./PlansAndPricesHome.vue?vue&type=template&id=19d93342&scoped=true&ts=true"
import script from "./PlansAndPricesHome.vue?vue&type=script&lang=ts"
export * from "./PlansAndPricesHome.vue?vue&type=script&lang=ts"

import "./PlansAndPricesHome.vue?vue&type=style&index=0&id=19d93342&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d93342"]])

export default __exports__